import src from "IMAGE";
export default { src, width: 840, height: 840, blurWidth: 0, blurHeight: 0};
